import { FC, ReactElement, ReactNode } from "react";
import { Box, CssBaseline, Grid, IconButton } from "@mui/material";
import SideBar from "../components/MySideBar";
import { useProSidebar } from "react-pro-sidebar";
import MenuIcon from '@mui/icons-material/Menu';


const Layout = ({ children }) => {
  const { collapseSidebar, toggleSidebar, collapsed, toggled, broken, rtl } = useProSidebar();

  const flexDirection = "column";
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { flexDirection },
        maxHeight: "100vh",
        maxWidth: "100vw",
        flexGrow: 1,
      }}
    >
      <CssBaseline />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Box mt={0.2} ml={0.2} mr={2}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <Box display={'flex'}>
                <IconButton size="large" onClick={() => { toggleSidebar()/* setMenuOpen(true) */ }}>
                  <MenuIcon sx={{ fontSize: '42px', color: '#BF2F38' }} />
                </IconButton>
                <a href="/">
                  <Box sx={{ paddingRight: '135px', paddingTop: '5px' }} component={'img'} src='/assets/logo-medicare-angola.svg' width={300} height={60} />
                </a>
              </Box>
              <Box>
                {/*                              <Stack direction={'row'} spacing={1} bgcolor={'#BF2F38'} color='#FFF' padding={1} paddingLeft={3} paddingRight={3} borderRadius={2} mt={1.5}>
                                    <Typography fontWeight={200}>Linha de Apoio Medicare</Typography>
                                    <img className="" src="/assets/phone.svg" width={24} height={24} />
                                    <Typography style={{ fontWeight: 900 }} component={'b'}>923 167 140</Typography>
                                </Stack> */}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <SideBar />
      <Box mr={8} ml={8} mt={4}>
        {children}
      </Box>
    </Box>
  );
};

export default Layout;